import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { defaultState } from './data/TranslationsState';

export const slice = createSlice({
  name: 'translations',
  initialState: defaultState,
  reducers: {
    setLocale: (draft, action: PayloadAction<string>) => {
      draft.locale = action.payload;
    },
  },
});
export const { setLocale } = slice.actions;
export default slice.reducer;
